<template>
  <div>
    <DriverListing />
  </div>
</template>

<script>
import DriverListing from '@/components/Drivers/Listing/DriverListing.vue'
export default {
  components: { DriverListing },
}
</script>
